export const headers = [
    'Caja',
    'Tipo',
    'Total',
    'Real',
    'Diferencia',
    'Creado',
    'Usuario'
];
export const keyColumns = [
    'cashRegisterName',
    'type',
    'total',
    'real',
    'diffDisplay',
    'created',
    'userEmail'
];

export const voucherHeaders = [
    'Origen',
    'Destino',
    'Total',
    'Añadido por'
]

export const voucherKeyColumns = [
    'origin',
    'destination',
    'total',
    'userEmail'
]

export const columns = [
    {
        field: 'cashRegisterName',
        header: 'Caja',
        sizes: { xs: 2 }
    },
    {
        field: 'type',
        header: 'Tipo',
        
        sizes: { xs: 1 }
    },
    {
        field: 'total',
        header: 'Total',
        sizes: { xs: 1 }
    },
    {
        field: 'real',
        header: 'Real',
        sizes: { xs: 1 }
    },
    {
        field: 'diffDisplay',
        header: 'Diferencia',
        sizes: { xs: 1 }
    },
    {
        field: 'created',
        header: 'Creado',
        type: 'date',
        sizes: { xs: 2 }
    },
    {
        field: 'userEmail',
        header: 'Usuario',
        sizes: { xs: 3 }
    },
];

export const title = 'Arqueos';

